/**
 * React Query key factory for store-related queries.
 * Follows the account/auth pattern: centralized, composable, type-safe.
 */

export const storeKeys = {
  all: ['store'] as const,
  products: () => [...storeKeys.all, 'products'] as const,
  product: (slug: string) => [...storeKeys.all, 'products', 'detail', slug] as const,
}
